import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { z } from "zod";

export const AZIMUT_DOCUMENTATION_SERVER_NAME = "azimut_documentation" as const;
export const AZIMUT_DOCUMENTATION_TOOLS_METADATA = [
  {
    name: "search_private_documentation",
    description:
      "Search private Azimut product documentation for setup, agents, skills, connections and troubleshooting. Return bounded reference excerpts. This tool never browses external websites.",
    schema: {
      query: z
        .string()
        .trim()
        .min(3)
        .max(500)
        .describe(
          "Question or keywords about Azimut. Search again with different terms if needed.",
        ),
    },
    stake: "never_ask",
    displayLabels: {
      running: "Searching Azimut documentation",
      done: "Search Azimut documentation",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;
export const AZIMUT_DOCUMENTATION_SERVER = {
  serverInfo: {
    name: AZIMUT_DOCUMENTATION_SERVER_NAME,
    version: "1.0.0",
    description: "Consult private Azimut product documentation.",
    authorization: null,
    icon: "ActionDocumentTextIcon",
    documentationUrl: null,
  },
  tools: AZIMUT_DOCUMENTATION_TOOLS_METADATA,
} as const satisfies ServerMetadata;
